import React, { createContext, useContext, useMemo, useState } from 'react';
const SubmitStatusContext = /*#__PURE__*/ createContext(undefined);
export const SubmitStatusProvider = ({ children })=>{
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccessMessage, setSubmitSuccessMessage] = useState();
    const [submitFailureCode, setSubmitFailureCode] = useState();
    const [submitFailureMessage, setSubmitFailureMessage] = useState();
    const value = useMemo(()=>({
            isSubmitting,
            submitSuccessMessage,
            submitFailureCode,
            submitFailureMessage,
            setIsSubmitting,
            setSubmitSuccessMessage,
            setSubmitFailureCode,
            setSubmitFailureMessage
        }), [
        isSubmitting,
        submitSuccessMessage,
        submitFailureCode,
        submitFailureMessage
    ]);
    return /*#__PURE__*/ React.createElement(SubmitStatusContext.Provider, {
        value: value
    }, children);
};
export const useSubmitStatus = ()=>{
    const context = useContext(SubmitStatusContext);
    if (context === undefined) {
        throw new Error('useSubmitStatus must be used within a SubmitStatusProvider');
    }
    return context;
};

//# sourceMappingURL=submit-status-context.js.map